import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import moment from 'moment'
import isEmpty from 'lodash.isempty'
import { withRouter } from 'react-router'
import { Layout, Container, Content, Footer, PageTitle } from 'src/components/Layout'
import Disclaimer from 'src/modals/Disclaimer'
import { getAddressFromLocation } from 'src/utils/helpers'

import ReviewItem from './ReviewItem'

import Button from 'src/components/Button/Button'
import withToast from 'src/components/Toast'
import styles from './styles.module.less'
import intlMessages from '../translations'
import intlMessagesWhatHappened from '../WhatHappened/translations'
import intlMessagesApp from 'src/modules/App/translations'

class Review extends Component {
  static contextTypes = {
    router: PropTypes.object,
  }

  state = {
    showDisclaimer: false,
  }

  componentDidUpdate(prevProps) {
    const { intl, submitting, successful, resetClaims, history, toast } = this.props

    if (submitting === false && prevProps.submitting === true && successful) {
      toast({
        title: intl.formatMessage(intlMessages.claimsNotificationThankYou),
        description: intl.formatMessage(intlMessages.claimsNotificationClaimSubmitted),
        status: 'success',
      })

      resetClaims()
      history.push('/')
    }

    if (submitting === false && prevProps.submitting === true && !successful) {
      toast({
        title: intl.formatMessage(intlMessagesApp.appErrorTitle),
        description: intl.formatMessage(intlMessages.claimsNotificationSomethinWentWrong),
        status: 'error',
      })
    }
  }

  handleBack = () => {
    this.props.history.push('/claims/form')
  }

  handleShowDisclaimer = () => {
    this.setState({
      showDisclaimer: true,
    })
  }

  handleCloseDisclaimer = () => {
    this.setState({
      showDisclaimer: false,
    })
  }

  handleSubmitClaim = () => {
    const {
      vehicle,
      geoLocation,
      weather,
      time,
      date,
      dateTimeDisplay,
      driver,
      driversLicenseFile,
      damage,
      witness,
      officer,
      passenger,
      note,
      pictures,
      vehicleAndDriver,
      otherDriversLicenseFile,
    } = this.props
    this.props.submitReview({
      vehicle,
      geoLocation,
      weather: {
        description: weather,
      },
      date: date && time ? date + ' ' + moment(time).format('hh:mm A') : null,
      dateTimeDisplay: dateTimeDisplay,
      driver,
      otherDriversLicenseFile,
      driversLicenseFile,
      damage: {
        description: damage.damage,
        type: this.formatWhatHappenedSubtitle(damage.type),
      },
      pictures: pictures.map(picture => {
        return { url: picture.url, id: picture.uid }
      }),
      vehicleAndDriver,
      officer,
      passenger,
      witness,
      note,
    })
  }

  formatPictures = pictures => {
    return pictures.reduce((acc, picture, key) => {
      acc[`picture ${key + 1}`] = (
        <a key={key} href={picture.url} target='_blank' rel='noopener noreferrer'>
          Link
        </a>
      )
      return acc
    }, {})
  }

  formatDriver = driver => {
    try {
      const { firstName, lastName, ...driverWithoutId } = driver
      // omitting id from driver data: should not be visible on the preview page
      return { firstName, lastName, ...driverWithoutId, id: undefined }
    } catch (e) {
      return driver
    }
  }

  formatObject = obj => {
    const { firstName, lastName, ...rest } = obj
    return { firstName, lastName, ...rest }
  }

  formatVehicleAndDriver = vehicleAndDriver => {
    const { intl } = this.props
    const { make, model, color, year, owner, firstName, lastName, ...rest } = vehicleAndDriver
    return {
      make,
      model,
      color,
      year,
      space: null,
      owner:
        owner === true
          ? intl.formatMessage(intlMessagesApp.appGlobalBoolYes)
          : intl.formatMessage(intlMessagesApp.appGlobalBoolNo),
      firstName,
      lastName,
      ...rest,
    }
  }

  formatWhatHappenedSubtitle = damageType => {
    const { intl } = this.props

    if (damageType === 'vehicle-collision') {
      return intl.formatMessage(intlMessagesWhatHappened.whatHappendVehicleCollision)
    }
    if (damageType === 'windshield-damage') {
      return intl.formatMessage(intlMessagesWhatHappened.whatHappendWindshieldDamage)
    }
    if (damageType === 'hit-and-run') {
      return intl.formatMessage(intlMessagesWhatHappened.whatHappendHitAndRun)
    }
    if (damageType === 'natural-disaster') {
      return intl.formatMessage(intlMessagesWhatHappened.whatHappendNaturalDisaster)
    }

    return damageType
  }

  renderPictures = (pictures = []) => {
    return pictures.map((picture, key) => {
      return (
        <div key={key} className={styles.uploadListItem}>
          <div className={styles.uploadListItemImageContainer}>
            <img src={picture.url} alt={`Uploaded ${key + 1}`} />
          </div>
        </div>
      )
    })
  }

  render() {
    const {
      vehicle,
      geoLocation,
      weather,
      dateTimeDisplay,
      driver,
      driversLicenseFile,
      damage,
      witness,
      officer,
      passenger,
      note,
      pictures,
      vehicleAndDriver,
      otherDriversLicenseFile,
      submitting,
      intl,
    } = this.props
    const { showDisclaimer } = this.state

    const driverLicense =
      driversLicenseFile && driversLicenseFile.hasOwnProperty('url')
        ? () => {
            return (
              <img
                src={driversLicenseFile.url}
                alt={intl.formatMessage(intlMessagesApp.altDriverLicense)}
              />
            )
          }
        : ''

    const otherDriverLicense =
      otherDriversLicenseFile && otherDriversLicenseFile.hasOwnProperty('url')
        ? () => {
            return (
              <img
                src={otherDriversLicenseFile.url}
                alt={intl.formatMessage(intlMessagesApp.altOtherDriverLicense)}
              />
            )
          }
        : ''
    return (
      <Layout className='m-claims-review claims-list'>
        <Content>
          <PageTitle
            showBack={true}
            title={intl.formatMessage(intlMessages.claimsPreview)}
            subtitle={intl.formatMessage(intlMessages.claimsFillOutTheForm)}
          />
          <Container padder className={styles.reviewContent + ' global-centered-desktop-content'}>
            <Content>
              <ReviewItem
                display-if={vehicle}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsVehicle)}
                data={vehicle}
              />
              <ReviewItem
                display-if={!isEmpty(geoLocation)}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsLocation)}
                data={{ address: getAddressFromLocation(geoLocation) }}
              />
              <ReviewItem
                display-if={weather}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsWeather)}
                data={{ description: weather }}
              />
              <ReviewItem
                display-if={dateTimeDisplay}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsTimeAndDate)}
                data={{ date: dateTimeDisplay }}
              />
              <ReviewItem
                display-if={driver}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsDriver)}
                data={this.formatDriver(driver)}
                renderBelow={driverLicense}
              />
              <ReviewItem
                display-if={damage.type}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsWhatHappened)}
                subtitle={this.formatWhatHappenedSubtitle(damage.type)}
                data={{ description: damage.damage }}
              />
              <div
                className={styles.reviewWrapper}
                // eslint-disable-next-line react/no-unknown-property
                display-if={!isEmpty(pictures)}
              >
                <div className={styles.reviewHeadline}>
                  <FormattedMessage id='app.claims.pictures' defaultMessage='Pictures' />
                </div>
                <div className={styles.uploadList}>{this.renderPictures(pictures)}</div>
              </div>
              <ReviewItem
                display-if={vehicleAndDriver}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsOtherVehicleAndDriver)}
                data={this.formatVehicleAndDriver(vehicleAndDriver)}
                renderBelow={otherDriverLicense}
              />
              <ReviewItem
                display-if={officer}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsInvestigatingOfficer)}
                data={this.formatObject(officer)}
              />
              <ReviewItem
                display-if={passenger}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsPassenger)}
                data={this.formatObject(passenger)}
              />
              <ReviewItem
                display-if={witness}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsWitness)}
                data={this.formatObject(witness)}
              />
              <ReviewItem
                display-if={note}
                intl={intl}
                title={intl.formatMessage(intlMessages.claimsNotes)}
                data={{ description: note }}
              />
            </Content>
            <Footer>
              <Button mt={'30px'} isFullWidth onClick={this.handleShowDisclaimer}>
                <FormattedMessage id='app.claims.submit' defaultMessage='Submit' />
              </Button>
            </Footer>
            <Disclaimer
              visible={showDisclaimer}
              loading={submitting}
              onClose={this.handleCloseDisclaimer}
              onSubmit={this.handleSubmitClaim}
            />
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(Review)))
